var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQnt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6644_36975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0249 1.42452L12.1207 8.56655L16.2124 6.15968C16.2124 6.15968 11.2758 -0.442041 9.95941 0.0245984C8.72159 0.49615 6.0249 1.42452 6.0249 1.42452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3647 6.15958C16.3647 6.15958 17.2931 4.5288 17.7548 2.35278C17.7548 2.35278 22.3869 4.21443 20.6087 8.87591L16.3647 6.15958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6089 8.88092L20.9969 13.7733L22.7702 13.5424C22.7702 13.5424 23.2319 13.3852 23.1582 12.5354C23.0796 11.6022 22.9273 9.66193 22.9273 9.66193C22.9273 9.66193 23.0059 9.19529 21.9253 9.04301C20.6089 8.80233 20.6089 8.88092 20.6089 8.88092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9918 13.7732L17.4404 16.6467L19.0614 19.8297C19.0614 19.8297 19.4494 21.0724 20.6038 19.6725C21.6844 18.2726 22.1461 18.0417 22.0675 17.187C21.9988 16.3323 21.763 14.3135 20.9918 13.7732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3666 16.6418L12.5037 14.4658L8.25979 23.0864C8.25979 23.0864 7.95033 23.7053 9.03097 23.7839C10.1116 23.9411 11.8848 24.3291 12.8132 23.3958C13.7416 22.546 17.3666 16.6418 17.3666 16.6418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5039 14.3921L12.0422 8.64502L1.54526 9.34743C1.54526 9.34743 0.926353 9.42603 1.00494 10.5902C1.08354 12.1424 1.23581 13.8517 1.23581 13.8517C1.23581 13.8517 1.15722 14.5492 2.54731 14.6278C3.9374 14.7015 12.3517 14.7015 12.5039 14.3921Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6644_36975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQnt);
export default __webpack_public_path__ + "static/media/qnt.30728586d1d11c3331e43f067cf2a2eb.svg";
export { ForwardRef as ReactComponent };